import { IsNotEmpty } from 'class-validator';
import { action, observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { UserApi } from '@intelingu/core/api/UserApi';
import { COMMON_NS } from '@intelingu/core/constants/base.constants';
import { lazyInject } from '@intelingu/core/IoC/container';
import { UserStore } from '@intelingu/core/stores/UserStore';
import Logger from '@intelingu/core/utils/Logger';
import withTranslation from '@intelingu/core/utils/withTranslation';
import { SubmitButton } from '../../../../partials/form/elements/SubmitButton';
import { TextInput } from '../../../../partials/form/elements/TextInput';
import { Field } from '@intelingu/core/components/form/Field';
import { Form } from '@intelingu/core/components/form/Form';

export interface EditProfileTabProps extends RouteComponentProps<any> {
    t?;
}

class ProfileRequest {

    @IsNotEmpty()
    display_name: string;

    @IsNotEmpty()
    first_name: string;

    @IsNotEmpty()
    last_name: string;

}

@withTranslation(COMMON_NS)
@observer export class EditProfileTab extends Component<EditProfileTabProps, any> {

    @lazyInject(UserStore) userStore: UserStore;
    @lazyInject(UserApi) userApi: UserApi;

    @observable isDone = false;
    @observable errorMessage;

    @action.bound async update(data: ProfileRequest, done) {
        try {
            this.errorMessage = undefined;
            await this.userApi.update(data);
            await this.userStore.loadProfile();

            this.isDone = true;
        } catch (e) {
            this.errorMessage = e.response.data.message;

            Logger.error(e);
        } finally {
            done();
        }
    }

    render() {
        const { match, t } = this.props;
        const { display_name, first_name, last_name } = this.userStore.user;

        return <div>
            <h3 className={'tab-title'}>{ t('profileFormTitle') }</h3>

            <Form
                validator={ProfileRequest}
                defaultData={{
                    display_name,
                    first_name,
                    last_name,
                }}
                onSubmit={this.update}
            >
                <div className={'row'}>
                    <div className={'col-sm-12'}>
                        <div className={'form-group'}>
                            <label htmlFor="email">{ t('profileFormScreenName') }</label>

                            <Field name={'display_name'} render={props => <TextInput {...props} />} />
                        </div>
                    </div>
                </div>

                <div className={'row'}>
                    <div className={'col-sm-6'}>
                        <div className={'form-group'}>
                            <label htmlFor="first_name">{ t('profileFormFirstName') }</label>

                            <Field name={'first_name'} render={props => <TextInput {...props} />} />
                        </div>
                    </div>

                    <div className={'col-sm-6'}>
                        <div className={'form-group'}>
                            <label htmlFor="email">{ t('profileFormLastName') }</label>

                            <Field name={'last_name'} render={props => <TextInput {...props} />} />
                        </div>
                    </div>
                </div>

                <div className={'form-group mb-sm-5'}>
                    <label>{ t('profileFormEmailAndPassword') }</label>

                    <div className={'row'}>
                        <div className={'col-sm-6'}>
                            { this.userStore.user.email }
                            <span className={'ml-4'}>••••••••</span>
                        </div>

                        <div className={'col-sm-6 mt-2 mt-sm-0'}>
                            <Link to={`${match.url}/credentials`} className={'red'}><i className={'ion ion-md-create mr-xs-1'} /> { t('profileFormChangeCredentials') }</Link>
                        </div>
                    </div>
                </div>

                { this.isDone && <div className={'alert alert-success'}>{ t('profileFormUpdatedMessage') }</div> }
                { this.errorMessage && <div className={'alert alert-danger'}>{ this.errorMessage }</div> }

                <Field submit render={props => <SubmitButton {...props}>{ t('profileFormSaveButton') }</SubmitButton>} />
            </Form>
        </div>
    }

}
